import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class ConfigurationService {
  private http = inject(HttpClient);

  getkeyValueList(skip: any) {
    return this.http.get(environment.apiUrl + 'config/list?$skip=' + skip + '&$limit=10')
  }

  public saveConfig(scope: any,_id: any) {
    if(_id==null)
      return this.http.post(environment.apiUrl + 'configuration', scope);
    else
      return this.http.put(environment.apiUrl + 'configuration/'+_id, scope);
  }
  public deleteConfig(id: any) {
    return this.http.delete(environment.apiUrl + 'configuration/' + id)
  }
}
